module.exports = __webpack_public_path__ + "step5.d737ab05.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/step5.jpg
// module id = Tb3F
// module chunks = 0